import { Component } from "@angular/core";

/**
 * bit-container is a minimally styled component that limits the max width of its content to the tailwind theme variable '4xl'. '4xl' is equal to the value of 56rem
 */
@Component({
  selector: "bit-container",
  templateUrl: "container.component.html",
})
export class ContainerComponent {}
